import { css } from '@bts-web/utils-style-engine';
import { HTMLRenderer } from '../../../../common/components/HTMLRenderer/HTMLRenderer';
import { ReactNode } from 'react';

const headerStyles = css({
  display: 'flex',
  flexDirection: 'column',
  gap: 'small',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
});

const headerTextStyles = css({
  color: 'neutrals.text_primary',
  fontSize: 'headline.large_semi_bold',
  fontWeight: 'headline.large_semi_bold',
  lineHeight: 'headline.large_semi_bold',
  letterSpacing: 'headline.large_semi_bold',
  textAlign: 'center',
});

export interface TransferWarningHeaderBoxProps {
  title: string;
  icon?: ReactNode;
}

export const TransferWarningHeaderBox = ({
  title,
  icon,
}: TransferWarningHeaderBoxProps) => {
  return (
    <div className={headerStyles} aria-label="transfer warning header">
      {icon}
      <div aria-label="transfer warning title" className={headerTextStyles}>
        <HTMLRenderer>{title}</HTMLRenderer>
      </div>
    </div>
  );
};
